<template>
  <div class="number-pond">
    <!-- 动画 -->
    <div id="myCanvasContainer" class="pond">
      <canvas id="myCanvas" ref="canvas" width="285" height="290">
        <p>换个现代浏览器吧！</p>
      </canvas>
      <div class="pond-cover" />
    </div>

    <!-- 滚球内数字 -->
    <div id="tags" class="number">
      <ul>
        <li v-for="(tag, index) in numbers" :key="index">
          <a
            onclick="return false"
            style="height: auto; font-size: 40px"
            v-html="tag"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import "@/assets/js/tagcanvas.min";

export default {
  name: "NumberPond",

  data() {
    return {};
  },
  computed: {
    numbers() {
      const list = [];
      for (let i = 1; i < 100; i++) {
        list.push(i);
      }
      // console.log(list, "companyList");
      return list;
    },
  },

  props: {
    isDraw: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    // this.createNumbers(); // 生成滚球数字
  },

  mounted() {
    this.start(); // 启动动画
  },

  methods: {
    // createNumbers() {
    //   const numArea = [3, 5, 7, 8];

    //   for (let i = 1; i < 40; i++) {
    //     const randomIndex = Math.floor(Math.random() * numArea.length);
    //     const secondNum = numArea[randomIndex];
    //   }
    // },

    start() {
      try {
        window.TagCanvas.Start("myCanvas", "tags", {
          textColour: "#0f6ccb",
          // textColour: '#0974F4',
          outlineColour: "transparent",
          dragControl: 1,
          decel: 0.95,
          textHeight: 11,
          minSpeed: 5,
          txtOpt: true,
          wheelZoom: false, // 鼠标不可放大放小
          initial: [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)],
          // maxSpeed: 5,
        });
        if (!this.isDraw) {
          window.TagCanvas.SetSpeed("myCanvas", [1.5, -0.25]);
        } else {
          window.TagCanvas.SetSpeed("myCanvas", [0.05, -0.25]);
        }
      } catch (e) {
        // something is wrong, hide the canvas container
        document.getElementById("myCanvasContainer").style.display = "none";
      }
    },
    hide() {
      window.TagCanvas.Pause("myCanvas");
    },
    speed() {
      window.TagCanvas.SetSpeed("myCanvas", [0.05, -0.25]);
    },
  },
};
</script>

<style lang="scss" scoped>
.number-pond {
  width: 285px;
  height: 290px;
  .number {
    display: none;
  }

  .pond {
    width: 285px;
    height: 290px;
    position: relative;

    .pond-cover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
